import BybButtonWrapper from "@Components/common/byb-ds/buttons/byb-button-wrapper";
import Icon from "@Components/generic/icon";
import { usePermissions } from "@Context/common/permissions/permissions";
import { IconDefinition } from "@fortawesome/pro-solid-svg-icons";
import { ButtonProps, capitalize, CircularProgress } from "@mui/material";
import { isString } from "lodash-es";
import { ButtonContent } from "./styled-components";

type ButtonShape = "default" | "pill";
type ButtonStatus = "not_started" | "completed" | "failed" | "winner";

export interface IBybButtonVR extends ButtonProps {
  icon?: IconDefinition;
  status?: ButtonStatus;
  loading?: boolean;
  shape?: ButtonShape;
}

const BybButtonVR = ({ icon, color = "primary", status, loading, children, size = "large", shape = "default", sx, ...props }: IBybButtonVR) => {
  const permissions = usePermissions?.();
  const isDisabled = !permissions?.canEdit || props.disabled || loading;

  return (
    <BybButtonWrapper
      {...props}
      color={color}
      size={size}
      sx={sx}
      data-shape={shape}
      data-status={status}
      disabled={isDisabled}
    >
      {!loading ? (
        <ButtonContent>
          {icon && <Icon icon={icon} size="xl" />}
          {children && (isString(children) ? capitalize(children) : children)}
        </ButtonContent>
      ) : (
        <CircularProgress />
      )}
    </BybButtonWrapper>
  );
};

export default BybButtonVR;
